import { ExtensionPackageParsedModel, WorkflowPayload } from 'features/workflows/types'
import { populateInputDefaults } from './utils'
import { Toolbox, getToolbox, Provider, WorkflowComponent } from '@cloud-native/workflows-engine'
import { workflowEngineClient } from '../clients/WorkflowEngineClient'
import { queryClient } from '../../../../queryClient'
import { KEYS } from '../../constants'
import { queryCustomComponents, queryPackageExtensions } from '../../api/queries'
import { componentsToMap, enrichComponentsWithExtension } from '../../utils/components'
import { getStore } from 'app/state/storeRegistry'
import { setToolboxComponents } from 'features/workflows/state/workflowsSlice'

export class ToolboxManager {
  toolbox: Toolbox | undefined

  async fetch(workflow: WorkflowPayload) {
    const engineConnection = workflowEngineClient.getWorkflowEngineConnection(workflow)

    let customComponents = await queryClient.fetchQuery({
      queryKey: [KEYS.customComponents, workflow.tempLocation.fqn],
      queryFn: async () => queryCustomComponents(workflow),
      retry: false,
      staleTime: Infinity
    })

    let extensions: ExtensionPackageParsedModel[] = []

    try {
      if ([Provider.BigQuery, Provider.Snowflake].includes(workflow?.config?.connectionProvider)) {
        extensions = await queryClient.fetchQuery({
          queryKey: [KEYS.packageExtensions],
          queryFn: async () => queryPackageExtensions(workflow),
          retry: false,
          staleTime: Infinity
        })
      }
    } catch (e) {
      extensions = []
    }

    const extensionsComponents = engineConnection.getExtensionComponentsFromQueryResponse(
      extensions.map((entry) => ({
        name: entry.name,
        metadata: JSON.stringify(entry.metadata)
      }))
    )

    if (!customComponents) {
      console.warn(`failed to load custom components for workflow ${workflow.id}`)
      customComponents = {}
    }

    const toolbox = getToolbox(
      workflow?.config?.connectionProvider,
      workflowEngineClient.getEnvVarsForProvider(workflow)
    )

    toolbox.components = {
      ...toolbox.components,
      ...customComponents,
      ...enrichComponentsWithExtension(componentsToMap(extensionsComponents.validComponents), extensions)
    } as Record<string, WorkflowComponent>

    // Populate components with defaults
    Object.keys(toolbox.components).forEach((component) => {
      toolbox.components[component].inputs = populateInputDefaults(toolbox.components[component].inputs)
    })

    this.toolbox = toolbox

    // Store components into redux
    getStore().dispatch(setToolboxComponents(toolbox.components))
  }
}
